import { useState, useCallback } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

const useDashboardSignature = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateSignedUrl = useCallback(async (userData) => {
    setLoading(true);
    setError(null);

    try {
      const functions = getFunctions();
      const generateSignature = httpsCallable(functions, 'generateDashboardSignature');
      
      console.log('🔐 Generating dashboard signature for user:', userData.uid);
      
      const result = await generateSignature({
        uid: userData.uid,
        email: userData.email,
        status: userData.status,
        role: userData.role,
        permissions: userData.permissions || []
      });
      
      console.log('✅ Dashboard signature generated successfully');
      
      return result.data.signedUrl;
      
    } catch (error) {
      console.error('❌ Error generating dashboard signature:', error);
      
      let errorMessage = 'Failed to generate dashboard access';
      
      if (error.code === 'unauthenticated') {
        errorMessage = 'Please log in to access dashboard';
      } else if (error.code === 'not-found') {
        errorMessage = 'User profile not found';
      } else if (error.code === 'permission-denied') {
        errorMessage = 'Access denied';
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setError(errorMessage);
      throw new Error(errorMessage);
      
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    generateSignedUrl,
    loading,
    error,
    clearError
  };
};

export default useDashboardSignature; 